import { render, staticRenderFns } from "./DUYQRQTE.vue?vue&type=template&id=6536c700&scoped=true&"
import script from "./DUYQRQTE.vue?vue&type=script&lang=js&"
export * from "./DUYQRQTE.vue?vue&type=script&lang=js&"
import style0 from "./DUYQRQTE.vue?vue&type=style&index=0&id=6536c700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536c700",
  null
  
)

export default component.exports